// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth"
import { getFirestore } from "firebase/firestore"
import { getStorage } from "firebase/storage"
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyCDkJSTSTQ666IZnxRu2_c-RSFStrukaDs",
//   authDomain: "crypto-exch.firebaseapp.com",
//   projectId: "crypto-exch",
//   storageBucket: "crypto-exch.firebasestorage.app",
//   messagingSenderId: "216149957468",
//   appId: "1:216149957468:web:139bde9875c90e182abf99",
//   measurementId: "G-K65ZPMQZ07"
// };
const firebaseConfig = {
  apiKey: "AIzaSyDIn-PGFtPqPQSUIPuWl-kTwPj8oIqoZXk",
  authDomain: "win24-ca503.firebaseapp.com",
  projectId: "win24-ca503",
  storageBucket: "win24-ca503.firebasestorage.app",
  messagingSenderId: "711886178775",
  appId: "1:711886178775:web:f84f1d166f28b81256a392",
  measurementId: "G-FBJEJEZQ78"
};

const app = initializeApp(firebaseConfig)

const auth = getAuth(app)
const db = getFirestore(app)
const storage = getStorage(app)

export { auth, db, storage }